import { authData } from "src/app/util/auth";
import { HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { DataService } from "src/app/http/data.service";

@Component({
  selector: "app-accommodation-index",
  templateUrl: "./accommodation-index.component.html",
})
export class AccommodationIndexComponent implements OnInit {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private dataService: DataService
  ) {}

  links: Link[] = [];

  loading = false;
  notification = {};
  refreshing = true;
  accommodation: any;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  requestPromise = this.dataService.accommodationChecks();

  ngOnInit(): void {
    const message: string = location.hash.slice(1);

    if (message) {
      if (message === "submittedtoqueue=1") {
        this.notification = {
          message:
            "Your accommodation request has been submitted. Kindly note that this is not a confirmation of allocation. You will receive an email when your request has been processed.",
        };
      } else if (message === "submittedtoqueue=0") {
        this.notification = {
          message: "Your accommodation reservation was successful.",
        };
      } else {
        this.notification = {
          message: message.replace(/\+/g, " "),
        };
      }
    }

    this.requestPromise
      .then((result: any) => {
        this.accommodation = result;

        this.links.push({
          title: "Accommodation Application",
          slug: "/accommodation/instructions",
          icon: "/assets/icons/home-button.png",
          text: "Add a line or two here that explains what this card does",
        });

        if (
          !this.accommodation.AccommodationEnabled ||
          !this.accommodation.SessionAccommodationEnabled ||
          !this.accommodation.EnabledForLevel ||
          !this.accommodation.AllowAccommodationAccess
        ) {
          this.links.pop();
        }

        if (this.accommodation.ActiveReservation)
          this.links.push({
            title: "Accommodation Booking",
            slug: "/accommodation/confirmation",
            icon: "/assets/icons/document.png",
            text: "Add a line or two here that explains what this card does",
          });

        if (this.accommodation.ReservationFullyPaid)
          this.links.push({
            title: "Accommodation Payment Confirmation",
            slug: "/accommodation/payment",
            icon: "/assets/icons/receipt.png",
            text: "Add a line or two here that explains what this card does",
          });

        if (this.accommodation.QueueAccommodation)
          this.links.push({
            title: "Accommodation Application Status",
            slug: "/accommodation/status",
            icon: "/assets/icons/history.png",
            text: "Add a line or two here that explains what this card does",
          });

        if (!this.links.length) {
          this.notification = {
            error: true,
            message: "Accommodation not enabled",
          };
        }
        this.refreshing = false;
      })
      .catch((error: any) => {
        this.refreshing = false;
        const err = JSON.parse(JSON.stringify(error));
        this.notification = {
          error: true,
          message: err?.error?.Message,
        };
      });
  }
}

interface Link {
  title: string;
  slug: string;
  icon: string;
  text: string;
}
